import type { Delta } from 'quill/core';
import Quill from 'quill/core';
import { useEffect, useState } from 'react';
import { useQuill } from '../editor/QuillContext';
import Header from '../editor/formats/Header';
import isInlineTextInsertion from '../editor/utils/isInlineTextInsertion';

export const useHasHeadings = () => {
  const { quill } = useQuill();

  const [hasHeadings, setHasHeadings] = useState<boolean | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!quill) {
      return undefined;
    }

    const getHasHeadings = () =>
      quill.scroll
        .descendants(Header)
        .some((header) => header.getText() !== '');

    const updateHasHeadings = (delta: Delta) => {
      setHasHeadings(
        (hasCurrentlyHeadings) =>
          (hasCurrentlyHeadings && isInlineTextInsertion(delta)) ||
          getHasHeadings(),
      );
    };

    setHasHeadings(getHasHeadings());

    quill.on(Quill.events.TEXT_CHANGE, updateHasHeadings);

    return () => {
      quill.off(Quill.events.TEXT_CHANGE, updateHasHeadings);
    };
  }, [quill]);

  return hasHeadings;
};
